import { render, staticRenderFns } from "./OnHold.vue?vue&type=template&id=286f0596"
import script from "./OnHold.vue?vue&type=script&lang=ts"
export * from "./OnHold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports